import { A03 } from 'api/U011';
import { sanitizeFileName } from 'commons/utils';

export interface DeleteResult {
  status: string;
  count: number;
  msg: string;
}

export const postMessage = async (
  userId: string,
  auditionId: string,
  message: string,
  file?: File | undefined
) => {
  try {
    const sanitizedFileName = file?.name ? sanitizeFileName(file.name) : undefined;
    const json = await A03(
      userId,
      auditionId,
      message,
      sanitizedFileName ?? undefined,
      file?.name ?? undefined
    );
    console.log({ json });

    if (file && json.url) {
      try {
        const isMp4orMov = sanitizedFileName?.match(/\.(mp4|mov|MP4|MOV)$/i);
        const uploadResponse = await fetch(json.url, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type,
            ...(isMp4orMov ? { 'Cache-Control': 'no-store' } : {}),
          },
        });

        if (!uploadResponse.ok) {
          throw new Error('file upload failed');
        }
      } catch (uploadError) {
        console.error('file upload error:', uploadError);
        throw uploadError;
      }
    }

    return {
      status: '00',
      msg: '',
    } as DeleteResult;
  } catch (err: unknown) {
    console.error(err);
    return {
      status: '99',
      count: 0,
      msg: err instanceof Error ? err.message : err,
    } as DeleteResult;
  }
};
